// extracted by mini-css-extract-plugin
export default {"holidayNotice":"HolidayNotice_holidayNotice__Eoyxh"};